import { Bar } from "react-chartjs-2";
import CustomerLoader from "../../../../../components/CustomLoader";
import { TableContainer } from "../../../Users/User.style";
import { Grid, GridColumn, GridColumnProps } from "@progress/kendo-react-grid";
import {
  CenteredWholeNumCell,
  HeaderCenteredCell,
} from "../../../../../components/DynamicGrid/customCells";
import { TotalRow } from "../../../../../components/DynamicGrid/customRows";
import { ChartContainer, NoData } from "../../style";
import {
  barOptions,
  doTransformData,
  handlePointClicked,
  prepareChartData,
  prepareTableData,
} from "../formUtils";
import { Child, Container, Header, LayerContent } from "../style";
import { useAnalyticsWrapper } from "../../../../../store/store";
import useAnalytics from "../../../../../hooks/useAnalytics";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import SectionModal from "./SectionModal";
import {
  handleCSVDownload,
  handlePDFDownload,
} from "../../../../../utils/helpers/pdfCsvUtils";
import { incidentLists } from "../../dummyData/colums";

const ShiftAndUnit = ({
  setClickedIncident,
  isFetchingSelectedIncident,
  shareTableData,
}: any) => {
  const [tableData, setTableData] = useState<any>([]);
  const [grid, setGrid] = useState<any>([]);
  const [unitChartData, setUnitChartData] = useState<any>([]);
  const [shift, setShift] = useState("");
  const [unit, setUnit] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [shiftUnitDetails, setShiftUnitDetails] = useState<any>([]);

  const { startDate, endDate, fallFacility } = useAnalyticsWrapper((state) => ({
    startDate: state.startDate,
    endDate: state.endDate,
    fallFacility: state.fallFacility,
  }));

  const { getOverviewOfShiftAndUnitFallIncidents, getShiftAndUnitDetails } =
    useAnalytics({
      facility: fallFacility?.value || "",
      startDate: moment(startDate).format("yyyy-MM-DD"),
      endDate: moment(endDate).format("yyyy-MM-DD"),
      uShift: shift,
      unit: unit,
    });

  const { data: shiftAndUnitData, isFetching: isFetchingShiftAndUnit } =
    getOverviewOfShiftAndUnitFallIncidents;

  const { data: shiftAndUnitDetailsData, isFetching: isLoadingDetails } =
    getShiftAndUnitDetails;

  const title = "Falls by Unit";

  useEffect(() => {
    if (shiftAndUnitData !== undefined) {
      const tempData = shiftAndUnitData?.data.data;
      const transformedData = doTransformData(
        tempData,
        "dataInfo",
        "shift",
        "Total"
      );
      const {
        countColumns,
        percentageColumns,
        data: transformedTableData,
      } = prepareTableData(transformedData);
      setTableData(transformedTableData);

      const { shiftChartData, unitChartData } =
        prepareChartData(transformedData);
      setTableData(transformedTableData);
      shareTableData(transformedTableData);
      setUnitChartData(unitChartData);
    }
  }, [shiftAndUnitData]);

  useEffect(() => {
    if (shiftAndUnitDetailsData) {
      const tempDetails = shiftAndUnitDetailsData.data.data.map((item: any) => ({
        ...item,
      }));
      setShiftUnitDetails(tempDetails);
    }
  }, [shiftAndUnitDetailsData]);

  const unitBarClicked = (chart: any) => {
    if (!chart.length) return;
    const label = handlePointClicked(chart, unitChartData?.labels);
    setShowModal(true);
    setUnit(label);
  };

  const shiftText = shift ? `(${shift})` : unit;
  const pageTitle = `${title} - ${shiftText}`;

  useEffect(() => {
    let cellCountProps = {
      cells: { data: CenteredWholeNumCell, headerCell: HeaderCenteredCell },
    };
    const grid = (
      <Fragment>
        <Grid
          data={tableData || []}
          scrollable="none"
          rows={{ data: TotalRow }}
        >
          <GridColumn field="unit" title="Unit" />
          <GridColumn
            field="11pm - 7am_count"
            title="11pm - 7am"
            {...(cellCountProps as GridColumnProps)}
          />
          <GridColumn
            field="7am - 3pm_count"
            title="7am - 3pm"
            {...(cellCountProps as GridColumnProps)}
          />
          <GridColumn
            field="3pm - 11pm_count"
            title="3pm - 11pm"
            {...(cellCountProps as GridColumnProps)}
          />
          <GridColumn
            field="total_count"
            title="Total"
            {...(cellCountProps as GridColumnProps)}
          />
        </Grid>
      </Fragment>
    );
    setGrid(grid);
  }, [tableData]);

  return (
    <LayerContent>
      {isFetchingShiftAndUnit ? (
        <CustomerLoader />
      ) : (
        <Fragment>
          <Header>{title}</Header>
          <Container>
            <Child flex="50%">
              <TableContainer>{grid}</TableContainer>
            </Child>
            <Child flex="50%">
              <ChartContainer id="unit-fall-chart">
                {unitChartData?.labels?.length > 0 ? (
                  <Bar
                    options={barOptions(unitBarClicked)}
                    data={unitChartData}
                  />
                ) : (
                  <NoData>No Data</NoData>
                )}
              </ChartContainer>
            </Child>
          </Container>
        </Fragment>
      )}
      {showModal ? (
        <SectionModal
          open={showModal}
          facilityName={fallFacility?.label}
          startDate={startDate}
          endDate={endDate}
          closeFn={() => setShowModal(false)}
          resetFn={() => {
            if (unit.length) setUnit("");
            if (shift.length) setShift("");
            setShiftUnitDetails(undefined);
          }}
          isLoading={isLoadingDetails || isFetchingSelectedIncident}
          tableData={shiftUnitDetails}
          title={pageTitle}
          getUserCallback={(item: any) => setClickedIncident(item)}
          handlePdfExport={() =>
            handlePDFDownload({
              data: shiftUnitDetails,
              columnData: incidentLists(),
              fileName: fallFacility?.label,
              startDate,
              endDate,
              subTitle: pageTitle,
            })
          }
          handleCsvExport={() =>
            handleCSVDownload(
              shiftUnitDetails,
              incidentLists(),
              `${fallFacility?.label} - ${pageTitle}`
            )
          }
        />
      ) : null}
    </LayerContent>
  );
};

export default ShiftAndUnit;
